import { render, staticRenderFns } from "./NotificationPanel.vue?vue&type=template&id=5a821489&"
import script from "./NotificationPanel.vue?vue&type=script&lang=ts&"
export * from "./NotificationPanel.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationPanel.vue?vue&type=style&index=0&id=5a821489&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/StratusCAD/ModelPipelineClient/model-pipeline-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a821489')) {
      api.createRecord('5a821489', component.options)
    } else {
      api.reload('5a821489', component.options)
    }
    module.hot.accept("./NotificationPanel.vue?vue&type=template&id=5a821489&", function () {
      api.rerender('5a821489', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/notifications/NotificationPanel.vue"
export default component.exports